import { IProcessVariable } from "../../processEditor/model/IProcessData";
import { AgentGroup, AgentVersionInfo } from "../../shared/model/AgentGroup";
import { HashMap} from "../../shared/model/HashMap";
import { Process } from "./Process";
import { ProcessVersionDetails } from "./ProcessVersion";

export class DeployDialogState {
    constructor(
        public showDeployDialog = false,
        public isSwitchVersion = false,
        public selectedProcesses: Process[] = [],
        public versionsToDeploy: HashMap<number> = Object.create(null),
        public processVersions: HashMap<ProcessVersionDetails[]> = Object.create(null),
        public agentVersions: AgentVersionInfo[] = [],
        public targetAgentGroupName = "",
        public targetEnvironmentName= "",
        public availableAgentGroups: AgentGroup[] = [],
        public suggestedProcessVariablesForDeployment: HashMap<IProcessVariable[]> = Object.create(null),
        public warnApiPassthroughConfiguration: string | null = null,
        public hasApiPassthroughConfiguration: boolean = false
    ) { }
}
